module.exports = __webpack_public_path__ + "img/austin-pool.37b91fe9.jpg";